import { styled } from '@linaria/react'
import { IconSC } from 'atoms/Icon'
import { MEDIA } from 'vars/index'
import { NoContentBlock } from '../NoContentBlock'

/* TODO: need to add to Icon component the ability to adapt the size of the icons to not to write it in different components */
export const NoContentBlockDisplayNoneSC = styled(NoContentBlock)`
  // when page-wrapper is :empty the display: flex; will added
  display: none;
  background: var(--color-background-dark-app);

  ${IconSC} {
    font-size: 5em;

    ${MEDIA.MIN_1240} {
      font-size: 7.5em;
    }
  }
`
